exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".canvasWrapper {\n    position: relative;\n    margin-top: 20px;\n}\n\n.canvas {\n    width: 100%;\n    height: 0;\n    -webkit-transform: rotate(180deg) scaleY(0.8);\n            transform: rotate(180deg) scaleY(0.8);\n}\n\n.canvas.started {\n    height: auto;\n}\n\n.offlineMessage {\n    text-align: center;\n}\n\n.ileotechLogo {\n    display: block;\n    position: absolute;\n    width: 10%;\n    bottom: 5%;\n    right: 0;\n    z-index: 1;\n}\n\n.ileotechLogo:hover {\n    opacity: 0.6;\n}\n\n.ileotechLogo svg {\n    width: 100%;\n}\n\n.cls-1 {\n    fill: rgba(150, 150, 150, 1);\n}\n\n.cls-2 {\n    fill: rgba(20, 20, 20, 1);\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/interactive-board/client/src/app/components/stream/stream.style.css
// module id = ../../../../../src/app/components/stream/stream.style.css
// module chunks = main